import DirectMessages from "discourse/plugins/chat/discourse/components/chat/routes/direct-messages";

export default <template><DirectMessages /></template>
